import React from 'react';
import { useAuth } from '../../auth/logic/authProvider';
import { useTheme } from '../../../shared/theme/ThemeContext';
import './HomePage.css';
import TimesheetsPage from '../../timesheet/ui/TimesheetsPage';
import { TimesheetProvider } from '../../timesheet/logic/timesheetProvider';
import { TasksCard } from '../../tasks';
import UserProfileCard, { UserProfileCardSkeleton } from './UserProfileCard';

const HomePage = () => {
  const { theme } = useTheme();
  const { user, isLoading } = useAuth();

  return (
    <div className="home-page" style={{ color: theme.text }}>
      {isLoading && !user ? <UserProfileCardSkeleton /> : <UserProfileCard user={user} />}
      
      <div className="home-page__spacer" />
      <TimesheetProvider>
        <TimesheetsPage />
      </TimesheetProvider>
      <div className="home-page__spacer" />
      <TasksCard />
      <div className="home-page__spacer" />
      <div className="home-page__spacer" />
      <div className="home-page__spacer" />
    </div>
  );
};

export default HomePage;
